<template lang="">
    <div>
        <div class="vx-row">
      <div class="vx-col w-full">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="from"
                          placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="to"
                          placeholder="Choose Date"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-6/6">             
                <vs-button id="search-button" :disabled="!from || !to" class="mt-4" color="success" size="small" @click.stop="onClickSearch">Search</vs-button>
            </div>
          </div>
          <div class="vx-row mt-8" v-if="summary_data.length > 0">
            <div class="vx-col md:w-2/3 sm:w-1/2 w-full">
                <vs-table :data="summary_data">

                    <template slot="thead">
                    <vs-th>Reason for Change</vs-th>
                    <vs-th>Adjust Quantity (KG)</vs-th>
                    <vs-th>Adjust Value (GBP)</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].reason_for_change">
                        {{ data[indextr].reason_for_change }}
                        </vs-td>

                        <vs-td :data="data[indextr].change_quantity">
                        {{ data[indextr].change_quantity }}
                        </vs-td>

                        <vs-td :data="data[indextr].change_sum">
                        {{ data[indextr].change_sum | currency}}
                        </vs-td>

                    </vs-tr>
                    </template>

                </vs-table>
            </div>
          </div>
      </div>
    </div>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')

import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'

export default {
    name: 'SundryItemAdjustStockLogSummary',
    data() {
        return {
            date: '',
            from: '',
            to: '',
            summary_data: []
        }
    },
    components: {
        flatPickr
    },
    methods: {
        async onClickSearch() {
            await this.$vs.loading({
                container: '#search-button',
                scale: 0.45
            })
            try {
                const { data } = (await InventoryRepository.getSundryItemAdjustLogSummary(this.from, this.to)).data
                this.summary_data = data
            } catch (e) {

            }
            this.$vs.loading.close('#search-button > .con-vs-loading')
        }
    },
}
</script>
<style lang="">
    
</style>